import React from 'react';

import Heading from '@atlaskit/heading';
import { Box } from '@atlaskit/primitives';

import { LabelContainer } from './styles';

/* eslint @typescript-eslint/ban-types: "warn" */
export const MetricsGroupLabel: React.FC<{ label: string }> = props => {
  return (
    <Box xcss={LabelContainer}>
      <Heading size="small">{props.label}</Heading>
    </Box>
  );
};
